import React, { Fragment } from "react";
import { Card, CardBody, Badge, CustomInput, Button, Row } from "reactstrap";
import { NavLink } from "react-router-dom";
import moment from 'moment';
import { Colxx } from "../../../../../../components/common/CustomBootstrap";
import ProductFormButton from "./ProductFormButton";

const colorPalette = [
  'primary',
  'secondary',
  'info',
  'success',
  'warning',
  'danger',
  'light',
  'dark',
];

const tagColorMap = {};

function getColorForTag(tag) {
  // If tag already has a color, return it
  if (tagColorMap[tag]) return tagColorMap[tag];

  // Otherwise assign a new color from the palette
  const color = colorPalette[Object.keys(tagColorMap).length % colorPalette.length];
  tagColorMap[tag] = color;

  return color;
}
const ProductListItem = ({ item, toggleModal, LoadData, categoryList }) => {
  // function generateRandomColor() {
  //   var arr = [
  //     'primary',
  //     'secondary',
  //     'info',
  //     'success',
  //     'warning',
  //     'danger',
  //     'light',
  //     'dark',
  //   ];
  //   return arr[Math.floor(Math.random() * arr.length)];
  // }

  return (
    <Row>
      <Colxx xxs="12">
        <Card
          className="d-flex flex-row mb-3"
          style={{ borderRadius: '10px' }}
        >
          <div className="pl-2 d-flex flex-grow-1 min-width-zero">
            <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
              <p className="mb-1  text-small w-20 w-sm-100">
                <b>{item.title != null ? item.title[0].statement : ''}</b>
              </p>
              <p className="mb-1 text-muted text-center text-small w-15 w-sm-100">
                {item.createdBy === 'dashboard' ? 'Dashboard'
                  : item.createdBy === 'Farehourbor' ? 'FareHarbor'
                    : item.createdBy === 'Ways' ? 'Way.IO'
                      : item.createdBy}
              </p>
              {/* <p className="mb-1  text-small w-20 w-sm-100">
                <b>{item.shortDescription != null ? item.shortDescription[0].statement : ''}</b>
              </p> */}
              <p className="mb-1 text-muted text-small w-10 w-sm-100">
                {item.categories.map((tag, index) => (
                  <Fragment key={index}>
                    <Badge color={getColorForTag(tag)} className="mt-1 mr-1">{tag}</Badge>
                  </Fragment>
                ))}
              </p>
              {/* <p className="mb-1 text-muted text-small w-15 w-sm-100">
              {item.tags.map((tag, index) => {
                return (
                  <Fragment>
                    {' '}
                    <Badge color={generateRandomColor()} className="mt-1" >{tag}</Badge>{' '}
                  </Fragment>
                );
              })}
            </p> */}
              <p className="mb-1 text-muted text-small w-10 w-sm-100 pl-2">
                {item.status}
              </p>
              <p className="mb-1 text-muted text-small w-15 w-sm-100 pl-2">
                {moment(item.createdUtc).format('MMM DD, YYYY hh:mm')}
              </p>
              <p className="mb-1 text-muted text-small w-15 w-sm-100 pl-2">
                {moment(item.lastModifiedUtc).format('YYYY') === '0001'
                  ? ''
                  : moment(item.lastModifiedUtc).format('MMM DD, YYYY hh:mm')}
              </p>
              <div className="w-10 w-sm-100">
                <ProductFormButton
                  id={item.id}
                  LoadData={LoadData}
                  categoryList={categoryList}
                  createdBy={item.createdBy}
                >
                </ProductFormButton>
              </div>
            </div>
          </div>
        </Card>
      </Colxx>
    </Row>
  );
};

export default React.memo(ProductListItem);
